/*
 * - Exposes class and methods to interact with the lookup API
 */

import request, { REQUEST_METHODS } from '@api/Request';
import { LookupEndpoints } from './config';
import {
  GetDistrictsResponse,
  GetNwpGpPermitTypesResponse,
  GetNwpGpPermitTypesOpts,
  GetAllLookupTablesResponse,
  GetCreditUnitsForDistrictResponse,
  GetDivisionsAndDistrictsResponse,
  GetHelpCategoriesResponse,
} from './types';

export default class LookupService {
  public static readonly getDistricts = (): Promise<GetDistrictsResponse> =>
    request({
      url: LookupEndpoints.getDistricts(),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getDivisionsAndDistricts = (): Promise<GetDivisionsAndDistrictsResponse> =>
    request({
      url: LookupEndpoints.getDivisionsAndDistricts(),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getNwpGpPermitTypes = async (): Promise<GetNwpGpPermitTypesOpts> => {
    const response: GetNwpGpPermitTypesResponse = await request({
      url: LookupEndpoints.getNwpGpPermitTypes(),
      method: REQUEST_METHODS.GET,
    });

    const opts =
      response?.data?.map((permit) => ({
        listId: 1,
        questionId: 8,
        dynamicTableColumnNumber: null,
        listTitle: 'Nationwide Permit Options',
        valueDesc: permit.value,
        value: permit?.permitNumber?.toString(),
      })) ?? [];

    return opts;
  };

  public static readonly getAllTables = (): Promise<GetAllLookupTablesResponse> =>
    request({
      url: LookupEndpoints.getAllTables(),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getCreditUnitsForDistrict = (district: string): Promise<GetCreditUnitsForDistrictResponse> =>
    request({
      url: LookupEndpoints.getCreditUnitsForDistrict(),
      method: REQUEST_METHODS.GET,
      params: { district },
    });

  public static readonly getHelpCategories = (active = true): Promise<GetHelpCategoriesResponse> =>
    request({
      url: LookupEndpoints.getHelpCategories(),
      method: REQUEST_METHODS.GET,
      params: { active },
    });
}
